import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "./jwt.service";
import { API_URL } from "../common/config-local";

const ApiService = {
  init(store) {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
    this.store = store;
  },

  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
  },

  get(resource, params, extra = {}) {
    let p = { params: params };
    let options = { ...p, ...extra };
    return Vue.axios.get(resource, options).catch(error => {
      if (error.response && error.response.status == 401) {
        this.store.dispatch("auth/logout");
      }
      throw error;
    });
  },

  post(resource, params) {
    return Vue.axios.post(`${resource}`, params).catch(error => {
      if (error.response && error.response.status == 401) {
        this.store.dispatch("auth/logout");
      }
      throw error;
    });
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params).catch(error => {
      if (error.response && error.response.status == 401) {
        this.store.dispatch("auth/logout");
      }
      throw error;
    });
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params).catch(error => {
      if (error.response && error.response.status == 401) {
        this.store.dispatch("auth/logout");
      }
      throw error;
    });
  },

  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      if (error.response && error.response.status == 401) {
        this.store.dispatch("auth/logout");
      }
      throw error;
    });
  }
};

export default ApiService;